import React, { Component } from 'react';
import { sendJson } from '../backend/Backend';
import '../css/style.css';
import './Home.css';
import './App.css';
import {Card} from 'react-bootstrap';
import { translate } from "react-i18next";
import i18n from "i18next";
import {GREY_LIGHT} from '../backend/Colors';






class UserAdd extends Component {

  constructor(props) {
    super(props);

    //userService.logout();

    this.state = {
        name: '',
        email:'',
        pwd:'',
        repwd:'',        
        submitted: false,
        loading: false,
        error: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

    handleChange(e) {
        const { name, value } = e.target;
        let oldState = this.state;
        this.setState({
          ...oldState, 
          [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        let oldState = this.state;
        this.setState({...oldState, 
          submitted: true });
        const { name, email, pwd, repwd } = this.state;
        console.log("Name :"+name);
        console.log("email :"+email);

        // stop here if form is invalid
        if (!email || !pwd || pwd.length < 6 || pwd !== repwd ) {
            return;
        }
        
        oldState = this.state;
        this.setState({...oldState, loading: true });
        this.setState({ loading: true });
        this.onUserAdd(name, email, pwd);
        
    }

   
    onUserAdd(name, email, pwd) {
      let uLang =    i18n.language;
      let user = {'name':name, 'email':email, 'pwd':pwd, 'lang': uLang};
        console.log("initialize users...."+user.email)
        sendJson('post', 'users/add', user).then(
            received => {
              //this.props.onAdd(received); 
              if(received){
                  console.log("user saved  :-)");
                  let oldState = this.state;
                  this.setState({...oldState, loading: false });
              }
            });
    }

    


  inputValid(){
    return this.state.email && this.state.pwd && this.state.repwd === this.state.pwd  && this.state.pwd.length >= 6;
  }

  render() {
    const { t } = this.props;
    const { name, email, pwd, repwd ,submitted, loading, error } = this.state;
    return (
            <Card style={{"background":GREY_LIGHT}}>
            <Card.Header className="text-primary"><h4>{t("registrieren")}</h4></Card.Header>
            <Card.Body>
              
                <form name="form" onSubmit={this.handleSubmit}>
                <div className={'form-group' }>
                    <input type="text" className="form-control" name="name" value={name} onChange={this.handleChange} 
                     placeholder={t("OptionalName")} maxLength={120} />
                </div>
                <div className={'form-group' + (submitted && !email ? ' has-error' : '')}>
                    <input type="text" className="form-control" name="email" value={email} onChange={this.handleChange} 
                     placeholder={t("regEmail")} maxLength={120} />
                    {submitted && !email &&
                        <div className="text-danger">{t("emailWarning")}</div>
                    }
                </div>
                <div className={'form-group' + (submitted && !pwd ? ' has-error' : '')}>
                    <input type="password" className="form-control" name="pwd" value={pwd} onChange={this.handleChange} placeholder={t("PasswortEingeben")} 
                    maxLength={250} />
                    {submitted && (!pwd || pwd.length < 6) &&
                        <div className="text-danger">{t("pwdMin")}</div>
                    }
                </div>
                <div className={'form-group' + (submitted && !repwd ? ' has-error' : '')}>
                    <input type="password" className="form-control" name="repwd" value={repwd} onChange={this.handleChange} placeholder={t("rePasswortEingeben")} 
                    maxLength={250} />
                    {submitted && (!repwd || repwd !== pwd) &&
                        <div className="text-danger">
                          {t("pwdNotCorrect")}
                          </div>
                    }
                </div>
                <div className="form-group">
                    <button className="btn btn-primary float-right" disabled={loading || !this.inputValid()}>{t("registrieren")}</button>
                    {loading &&
                        <img alt="loading..." src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                </div>
                {error &&
                    <div className={'alert alert-danger'}>{error}</div>
                }
            </form>
            </Card.Body>
            </Card>
    );
}

}


export default translate("translations")(UserAdd);

